// @flow
import groupItems from './groupItems';
import groupActivity from './groupActivity';


const filterId: 'group' = 'group';
export default filterId;

export { groupItems, groupActivity };
